// export const domain = 'dev.engagement-card.com'; // 测试环境
// export const baseUrl = 'dev.engagement-card.com/dev'; // 测试环境
export const domain = 'online.engagement-card.com'; // 正式环境
export const baseUrl = 'online.engagement-card.com'; // 正式环境
export const revertFreePlan = false;
// export const revertFreePlan = true;



// WEBPACK FOOTER //
// ./src/utils/global.js